export default __webpack_public_path__ + "static/media/3.250fad2f.jpg";